import { Globe } from "lucide-react";
import { useTranslation } from "@/i18n/LanguageContext";

export default function LanguageToggle({ variant = "desktop" }) {
  const { lang, setLang } = useTranslation();

  const isMobile = variant === "mobile";

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center rounded-full bg-white/[0.03] ring-1 ring-orange-500/25 p-0.5 ${
        isMobile ? "" : ""
      }`}
    >
      <Globe className="w-3.5 h-3.5 text-orange-300 ml-2 mr-1" />
      {[
        { id: "en", label: "EN" },
        { id: "zh", label: "中文" },
      ].map((opt) => (
        <button
          key={opt.id}
          onClick={() => setLang(opt.id)}
          data-testid={`lang-${opt.id}`}
          className={`px-3 py-1 text-xs font-semibold tracking-wider rounded-full transition ${
            lang === opt.id
              ? "bg-gradient-to-b from-orange-400 to-orange-600 text-black"
              : "text-zinc-300 hover:text-orange-200"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
